interface Window {
  ethereum?: any;
}

export function detectEthProvider(timeout = 3000): Promise<any> {
  let handled = false;

  return new Promise((resolve, reject) => {
    if ((window as Window).ethereum) {
      handleConnection();
    } else {
      window.addEventListener("ethereum#initialized", handleConnection, {
        once: true,
      });

      setTimeout(() => {
        handleConnection();
      }, timeout);
    }

    function handleConnection() {
      if (handled) {
        resolve((window as Window).ethereum as unknown as any);
        return;
      }
      handled = true;

      window.removeEventListener("cede#initialized", handleConnection);

      const { ethereum } = window as Window;

      if (ethereum) {
        resolve(ethereum as unknown as any);
      } else {
        reject(new Error("Ethereum provider not found"));
      }
    }
  });
}
